"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LegacyTokenService = void 0;
var _getTokenClients = require("../internals/getTokenClients");
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- this is for TSDoc

const getUserAccessToken = async () => (0, _getTokenClients.getTokenClients)().userTokenClient.getToken();
const getPublicAccessToken = async () => (0, _getTokenClients.getTokenClients)().publicTokenClient.getToken();

/**
 * This component adds compatibility layer to old SPAs taking token from object on window provided by Online layout.
 * We shouldn't need this in the future, SPAs should use dedicated react token providers.
 *
 * @deprecated Use {@link UniversalTokenProvider | `UniversalTokenProvider`}/`PrefetchedTokenProvider`/`StandaloneTokenProvider` with `useToken` hook
 */
const LegacyTokenService = () => {
  if (typeof window !== 'undefined' && !window.ori?.tokenService) {
    window.ori = {
      ...window.ori,
      tokenService: {
        getToken: getUserAccessToken,
        getPublicToken: getPublicAccessToken
      }
    };
  }
  return null;
};
exports.LegacyTokenService = LegacyTokenService;
